<template>
  <div class="input">
    <span class="input__label" v-if="label">{{label}}</span>
    <div class="input__input-wrapper">
      <input
          :type="type"
          :value="value"
          :placeholder="placeholder || ''"
          @input="updateValue"
          class="input__input"
          v-bind="$attrs"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicInput",
  props: {
    value: [String, Number],
    label: [String],
    placeholder: [String],
    type: {
      type: String,
      required: true
    },
    valueModifier: {
      type: Function
    }
  },
  methods: {
    updateValue(event) {
      let value = event.target.value;
      if (this.valueModifier) {
        value = this.valueModifier(value)
        event.target.value = value;
      }
      this.$emit('input', value);
    }
  }
}
</script>

<style scoped lang="scss">
.input {
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }

  &__label {
    font-size: 1.2rem;
    line-height: 1.5rem;
    margin-right: 1rem;
    white-space: nowrap;
    color: #979797;
    margin-left: 2rem;
  }

  &__input {
    position: relative;
    z-index: 3;
    background-color: transparent;
    height: 3.6rem;
    padding: 0 3rem 0 1.1rem;
    font-size: 1.2rem;
    line-height: 1em;
    color: #2e2e2e;
    outline: none;
    box-shadow: none;
    border-radius: 3px;
    border: 1px solid #bcbcbc;
    transition-property: border-color, background-color;
    transition-duration: 0.3s;
    transition-timing-function: ease;
    width: 100%;

    &-wrapper{
      width: 100%;
    }

    &:disabled {
      border: 1px solid #bcbcbc50;
      color: #2e2e2e50;
    }
  }

}
</style>